import { render } from "./BrandLogo.vue?vue&type=template&id=47c3d7e2&bindings={\"size\":\"props\"}"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"
script.render = render

export default script